const COUNT_KEY = 'manga_read_count';

// Increment the per-session PV counter and inject the interstitial on every 5th open.
// Exported for unit testing.
export const handlePageOpen = (injectFn) => {
  try {
    const count = parseInt(window.sessionStorage.getItem(COUNT_KEY) || '0', 10) + 1;
    window.sessionStorage.setItem(COUNT_KEY, String(count));

    if (count % 5 === 0) injectFn();
  } catch (e) {
    // sessionStorage unavailable (e.g. iOS private mode) — skip counting
  }
};

// Wire counting to the page lifecycle.
// Runs on fresh load + bfcache restore (browser back/forward) via the pageshow event.
const initMangaInterstitial = (injectFn) => {
  if (!window.mangaInterstitialEnabled) return;

  handlePageOpen(injectFn); // fresh page load

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) handlePageOpen(injectFn); // restored from bfcache
  });
};

export default initMangaInterstitial;
